import React from "react";
import T from "prop-types";

import { PlaceholderText } from "2g-placeholder";

function TextComponent({ loading = false, children }) {
  const Wrapper = loading ? PlaceholderText : React.Fragment;
  return <Wrapper>{children}</Wrapper>;
}

TextComponent.propTypes = {
  loading: T.bool.isRequired,
  children: T.any
};

export default React.memo(TextComponent);
